import React, { useState, useEffect } from 'react'
import { Button, Table, message } from 'antd'
import CreateEnquiry from './CreateEnquiry'
import { fulcrumRequest } from '../../../utilities/fulcrum'
import { invalidateFulcrumCache } from '../../../utilities/fulcrumData'
import * as columns from '../columns'
import moment from 'moment'

export default ({ QualityPlans }) => {
  const [visible, setVisible] = useState(false)
  const [selectedEnquiry, setSelectedEnquiry] = useState(null)
  const [enquierys, setEnquierys] = useState([])

  useEffect(() => {
    if (QualityPlans) setEnquierys(QualityPlans.filter(r => ['Enquiry'].includes(r.status)))
  }, [QualityPlans])

  const onClose = () => {
    setVisible(false)
    setSelectedEnquiry(null)
  }

  const onCreate = r => {
    fulcrumRequest({ method: 'create', record: r })
      .then(() => {
        invalidateFulcrumCache('QualityPlans')
        setVisible(false)
        setEnquierys([...enquierys, r])
      })
      .then(smth => message.success('Enquiry form added.'))
      .catch(err => message.error('An error occured.'))
  }

  const onUpdate = (r, kill) => {
    if (kill) r.status = 'Dead'
    fulcrumRequest({ method: 'update', id: r.id, record: r })
      .then(() => {
        invalidateFulcrumCache('QualityPlans')
        setVisible(false)
        let _enquierys = [...enquierys]
        let index = enquierys.findIndex(i => i.id === r.id)
        kill ? _enquierys.splice(index, 1) : (_enquierys[index] = r)
        setEnquierys(_enquierys)
      })
      .then(smth => message.success('Enquiry form updated.'))
      .catch(err => message.error('An error occured.'))
  }

  useEffect(() => {
    if (selectedEnquiry) {
      setVisible(true)
      console.log(selectedEnquiry)
    }
  }, [selectedEnquiry])

  return (
    <div>
      <h2>Enquirys</h2>
      <Button type='primary' onClick={() => setVisible(true)} ghost style={{ marginBottom: 15 }}>
        New Client Enquiry
      </Button>
      <Table
        pagination={{ position: 'bottom', pageSize: 10 }}
        bordered
        id='postTable'
        className='tableResizer'
        columns={columns.ENQUIRY(setSelectedEnquiry, onUpdate)}
        dataSource={enquierys.sort((a, b) => moment(a.form_values['ce91']).isBefore(moment(b.form_values['ce91'])))}
        rowKey='id'
        size='middle'
      />
      <CreateEnquiry
        visible={visible}
        onClose={onClose}
        onCreate={onCreate}
        onUpdate={onUpdate}
        viewEnquiry={selectedEnquiry}
      />
    </div>
  )
}
